import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MenusState } from "./menus.state";
import { getMenus } from "./menus.thunk";
import { MenuItem, MenusResponse } from "./menus.types";

const initialState: MenusState = {
  data: null,
  error: null,
  status: "idle",
};

const menusSlice = createSlice({
  name: "menus",
  initialState,
  reducers: {
    resetMenus: (state) => {
      state.data = null;
      state.error = null;
      state.status = "idle";
    },
    // SSR'dan gelen initial menus verisini store'a yaz (ISR cache hit)
    setMenus: (state, action: PayloadAction<MenuItem[]>) => {
      state.data = action.payload;
      state.status = "success";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMenus.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getMenus.fulfilled,
        (state, action: PayloadAction<MenusResponse>) => {
          state.status = "success";
          state.data = action.payload.data;
        }
      )
      .addCase(
        getMenus.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Bir hata oluştu.";
        }
      );
  },
});

export const { resetMenus, setMenus } = menusSlice.actions;
export default menusSlice.reducer;